import { BarChart3, MessageSquare, Settings, Target, Trophy } from "lucide-react";

const bottomItems = [
  { id: "home", label: "Start", icon: Trophy },
  { id: "train", label: "Üben", icon: Target },
  { id: "overview", label: "Übersicht", icon: BarChart3 },
  { id: "feedback", label: "Melden", icon: MessageSquare },
  { id: "settings", label: "Optionen", icon: Settings },
] as const;

export type BottomNavId = (typeof bottomItems)[number]["id"];

export function BottomNav({ activeId, onSelect }: { activeId: string; onSelect: (id: BottomNavId) => void }) {
  return (
    <nav className="bottom-nav" aria-label="Mobile Navigation">
      {bottomItems.map((item) => {
        const Icon = item.icon;
        return (
          <button
            className={activeId === item.id ? "is-active" : ""}
            key={item.id}
            onClick={() => onSelect(item.id)}
            type="button"
          >
            <Icon size={20} />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
